import React from 'react'
import { connect } from 'react-redux'
import IngresarCamionSinCupo from './IngresarCamionSinCupo'
import { ingresarCPASinCupo } from '../../camionesSinCupo/actions/TablaCamionesSinCupoActions'

function OperacionesCamionesSinCupo (props) {
  const { numero, roles, ingresarCPASinCupo } = props

  const rol = roles.filter(roles => roles === 'SUPERVISOR' || roles === 'DESARROLLADOR')
  const rolAutorizado = (rol[0] === 'SUPERVISOR' || rol[0] === 'SUPMANTENIMIENTO' || rol[0] === 'DESARROLLADOR')

  return (
    <>
      {rolAutorizado && <IngresarCamionSinCupo
        numero={numero}
        ingresar={ingresarCPASinCupo}
      />
      }
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    roles: state.auth.roles
  }
}

const mapActionsToProps = {
  ingresarCPASinCupo
}
const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(OperacionesCamionesSinCupo)
